import { render, staticRenderFns } from "./MenuImagesList.vue?vue&type=template&id=7d7a4152"
import script from "./MenuImagesList.vue?vue&type=script&lang=js"
export * from "./MenuImagesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports